module.exports = __webpack_public_path__ + "menu_2_pc.b33101b3.png";